<template>
  <div class="select native-select">
    <select
      :value="value"
      :disabled="disabled"
      :[tabindexAttr]="tabindex"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
      @change="handleChange"
    >
      <option
        v-if="hasDefaultBlank"
        value=""
        disabled
        selected
      >
        {{ placeholder }}
      </option>
      <option
        v-for="option in visibleOptions"
        :key="option.value"
        :value="option.value"
      >
        {{ option.name }}
      </option>
    </select>
  </div>
</template>

<script>
import { isOptionVisible } from './helpers';

export default {
  name: 'NativeSelect',
  props: {
    value: { type: [String, Number, Boolean], default: '' },
    options: { type: Array, required: true },
    placeholder: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    hasDefaultBlank: { type: Boolean, default: true },
    tabindex: { type: [Number, String], default: null },
  },
  computed: {
    visibleOptions() {
      return this.options.filter(isOptionVisible);
    },
    tabindexAttr() {
      return this.tabindex != null ? 'tabindex' : null;
    },
  },
  mounted() {
    this.syncSelection();
  },
  updated() {
    this.syncSelection();
  },
  methods: {
    // `:value` is applied before the new option exists: the browser falls back to the first.
    syncSelection() {
      const select = this.$el?.querySelector('select');
      const target = String(this.value ?? '');

      if (!select || select.value === target) return;
      if (!this.visibleOptions.some((option) => String(option.value) === target)) return;

      select.value = target;
    },
    handleChange(event) {
      const rawValue = event.target.value;
      const match = this.options.find((option) => String(option.value) === rawValue);
      const value = match ? match.value : rawValue;

      this.$emit('input', value);
      this.$emit('change', value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/src/_fieldSignature.scss';

.native-select {
  display: block;
  // Bulma fixes the wrapper at 2.5em (40px), shorter than the 42px select.
  height: auto;

  select {
    @include field-frame;
    @include field-text;
    @include field-focus;
    width: 100%;
    display: block;

    option { color: black; }
    &:disabled { border: #D1D5DB solid 1px; }
  }
}
</style>
